import axios from 'axios'
import Http from './Http'

class AuthService extends Http {
  constructor () {
    super('/auth')
  }

  async facebook (payload) {
    const data = await this.store('/facebook', payload)
    localStorage.setItem('jwt', data.token)
    axios.defaults.headers['Authorization'] = `Bearer ${data.token}`
    return data
  }

  async google (payload) {
    const data = await this.store('/google', payload)
    localStorage.setItem('jwt', data.token)
    axios.defaults.headers['Authorization'] = `Bearer ${data.token}`
    return data
  }

  logout () {
    axios.defaults.headers['Authorization'] = null
    localStorage.removeItem('jwt')
  }
}

export default new AuthService()
